module.exports = {
  "id": "stick",
  "title": "stick",
  "image": "provision/parts/stick/stick.png",
  "info": [
    {
      "text": "Add a stick to your project",
      "image": "provision/parts/stick/stick.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/stick/stick.png"
} ;